import React, { useState, useEffect } from 'react';
import {
    Link,
    useLocation,
    useHistory
} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import { servicesReplaced } from '../../../../store/reducers/selServReducer';
import { pathAdded } from '../../../../store/reducers/pathsReducer';
import { classAddedMobile, scrollMobileSelector } from '../../../../store/reducers/scrollMobileReducer';
import { promoCodeSelector } from '../../../../store/reducers/promoCodeReducer';
import { registrationSettingsSelector } from '../../../../store/reducers/registrationSettingsReducer';

function SelectServices() {
    const promoCode = useSelector(promoCodeSelector);
    const scroll = useSelector(scrollMobileSelector);
    const dispatch = useDispatch();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const summary = params?.get("summary");
    const [scrollClass, setScrollClass] = useState(scroll);
    const [magnet, setMagnet] = useState("Magnet JQS HuRi-Only");
    let history = useHistory();
    const registrationData = useSelector(registrationSettingsSelector);
    const [promoCodeIs, setPromoCodeIs] = useState(false);
    const [fromSummary, setfromSummary] = useState(false);
    
    useEffect(() => {
        window.scrollTo(0, 0);

        if(summary) {
            setfromSummary(summary);
        }
        if(promoCode.isHuri === true) {
            setPromoCodeIs(promoCode.isHuri);
        } else {
            setMagnet("Magnet JQS Basic");
        }
    }, []);  // eslint-disable-line
    
    useEffect(() => {
        setTimeout(function(){ setScrollClass("progression_container small") ; }, 10);
    }, []); // eslint-disable-line

    function handleNext(e) {
        if(promoCodeIs === true) {
            if(summary && e.target.classList[0] === "summaryNavButton") {
                dispatch(classAddedMobile("progression_container small startBottom"));
                dispatch(servicesReplaced(magnet));
                dispatch(pathAdded(history.location.pathname));
                history.push("/form/summary");
            } else {
                dispatch(pathAdded(history.location.pathname));
                dispatch(servicesReplaced(magnet));
                dispatch(classAddedMobile("progression_container small startBottom"));
                history.push("/form/info");
            }
        } else {
            if(summary && e.target.classList[0] === "summaryNavButton") {
                dispatch(classAddedMobile("progression_container small startBottom"));
                dispatch(pathAdded(history.location.pathname));
                dispatch(servicesReplaced(magnet));
                history.push("/form/summary");
            } else {
                dispatch(classAddedMobile("progression_container small startBottom"));
                dispatch(pathAdded(history.location.pathname));
                dispatch(servicesReplaced(magnet));
                history.push("/form/info");
            } 
        }
    };

    return (          
        <div className={scrollClass}>
            {promoCodeIs ?
                <>
                    <h2>Confirm service</h2>
                    <div className="services-huri">
                        <p>Service:</p> 
                        <p className="service clicked">Magnet JQS HuRi-Only</p>
                    </div>
                    <p>Your company will be nominated for a Human Rights assessment by one of your clients.</p>
                    <br/>
                    <p>The assessment will be conducted through an industry collaboration and this service is coordinated by Offshore Qualific.</p>
                    <br/>
                    <p>This industry approach allows you to demonstrate respect for human rights towards other potential clients, and to obtain timesaving assessments processes.</p>
                    <br/>
                    <p>Once you have been successfully onboarded, the Requestor will be notified and confirm the nomination. You will receive a system notification with instructions once the nomination has been confirmed.</p>
                </>
                :<>
                    <h2>Confirm service</h2>
                    { registrationData.registration_text ? 
                        <>
                            <p className="fee">{registrationData.registration_text}</p>
                            <p className="fee-bottom">{registrationData.registration_text_bottom}</p>
                        </>
                        :
                        <p className="fee">Please note that there is a yearly service fee of NOK 5 700 (excl. VAT) for access to Magnet JQS Basic</p>
                    }                
                </>
            }

            <div className="button_container">
                {!fromSummary ? (
                    <Link to="/" className="previous"><span>
                        <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z" fill="white"></path>
                        </svg>
                    </span> {promoCodeIs ? "Find company" : "Previous"}</Link>                
                    ) : <button className="summaryNavButton" onClick={handleNext} type="submit">Back to summary</button>   
                }

                <button onClick={handleNext} className="nextSubmit next plausible-event-name=Registration+Confirm+Services"><span>Next</span>
                    <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z" fill="white"></path>
                    </svg>
                </button>
            </div>
        </div>
    );
}

export default SelectServices;
